/* ============================================================
   cro-fixes.js — Adorn Silver CRO house file (JS side)
   Loaded deferred from layout/theme.liquid. JS sibling of
   assets/cro-fixes.css. Delete this file + its <script> to
   roll back; nothing else references it.

   Log
   ---
   2026-08-24  T12       Clarity smart events
   2026-08-24  CRO-003   Judge.me badge dead click
   2026-09-05  PDP-104   instant price on variant change
   2026-09-06  PDP-104b  attach unconditionally + rAF repaint
                         (load-time guard bailed on live; theme sync-swaps
                          the price node right after paint, so repaint on the
                          next frame to win the flash)
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     T12 — Clarity smart events.

     Purchase cannot be tracked here: checkout is Shopflo and
     off-domain. These three are the last on-domain steps we can
     see, which makes recordings filterable by intent.

     Clarity is injected by an app embed and can land after this
     file, so events queue until window.clarity exists.
     ---------------------------------------------------------- */
  var queue = [];
  var lastSent = {};
  var clarityReady = false;

  function flush() {
    if (typeof window.clarity !== 'function') { return; }
    clarityReady = true;
    while (queue.length) {
      try { window.clarity('event', queue.shift()); } catch (e) { /* never break the page for analytics */ }
    }
  }

  function track(name) {
    // Two taps on the same button inside a second is one intent, not two.
    var now = Date.now();
    if (lastSent[name] && now - lastSent[name] < 1000) { return; }
    lastSent[name] = now;
    queue.push(name);
    flush();
  }

  if (typeof window.clarity !== 'function') {
    var tries = 0;
    var iv = setInterval(function () {
      flush();
      if (clarityReady || ++tries > 40) { clearInterval(iv); }
    }, 250);
  }

  var ADD_TO_CART =
    'button[name="add"], [data-add-to-cart], [data-add-to-cart-secondary], .pplr_atc_form [type="submit"]';
  var BEGIN_CHECKOUT =
    '[name="flo-buy-now-button"], [data-adorn-cart-btn], .flo-header-cart-btn, [data-buy-now-button], .shopify-payment-button__button';
  var CUSTOMISE =
    '.product-personalizer .ptc_button, .product-personalizer button, [data-adorn-customize]';

  // Capture phase: adorn-sticky-customize.liquid calls
  // stopImmediatePropagation on the personaliser button, and the
  // document runs before the element either way.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    if (t.closest(ADD_TO_CART)) { track('AddToCart'); }
    if (t.closest(BEGIN_CHECKOUT)) { track('BeginCheckout'); }
    if (t.closest(CUSTOMISE)) { track('Customise'); }
  }, true);

  // The personalised line item is added by the app, not by a form
  // submit, so the click above never sees it.
  window.addEventListener('pplrAddToCartCompleted', function () { track('AddToCart'); });

  /* ----------------------------------------------------------
     CRO-003 — Judge.me preview badge.

     The badge ships as a <div> with cursor:pointer and no link:
     a store-wide dead click on every PDP and product card. On a
     PDP, send it to the review widget. Product cards already
     navigate to the PDP, so leave those alone.
     ---------------------------------------------------------- */
  function scrollToReviews() {
    var target = document.getElementById('judgeme_product_reviews') ||
                 document.querySelector('.jdgm-rev-widget, .jdgm-widget.jdgm-review-widget');
    if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }

  function wireReviewBadges() {
    // VERIFIED 2026-08-24: the PDP badge lives in
    // product-info > .product-single__wrapper on this theme, not in
    // .product-single__meta. Scope to the buy box and skip the copies
    // inside product cards, which already link to their own PDP.
    var box = document.querySelector('.product-single__wrapper');
    if (!box) { return; }
    var target = document.getElementById('judgeme_product_reviews') ||
                 document.querySelector('.jdgm-rev-widget, .jdgm-widget.jdgm-review-widget');
    if (!target) { return; }

    var badges = box.querySelectorAll('.jdgm-widget.jdgm-preview-badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (b.getAttribute('data-adorn-reviews-link')) { continue; }
      if (b.closest('.product-grid-item')) { continue; }
      b.setAttribute('data-adorn-reviews-link', '1');
      b.setAttribute('role', 'link');
      b.setAttribute('tabindex', '0');
      b.style.cursor = 'pointer';
      b.addEventListener('click', scrollToReviews);
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToReviews(); }
      });
    }
  }

  // Both the badge and the review widget are injected late, and the
  // theme re-renders the buy box on variant change.
  wireReviewBadges();
  document.addEventListener('DOMContentLoaded', wireReviewBadges);
  if (window.MutationObserver && document.body) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) { return; }
      pending = setTimeout(function () { pending = null; wireReviewBadges(); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ============================================================
   PDP-104 — Instant price on variant change.
   2026-09-05, hardened 2026-09-06 (PDP-104b)
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     WHY: on variant change this theme fetches the ENTIRE product
     section from Shopify (?section_id=...__product&option_values=)
     and only updates the price when that round trip lands
     (~700-1000ms, with a wrong intermediate state). On a phone it
     reads as "the price didn't change".

     FIX: on any option radio/select change, look the variant up
     locally and write the price into the DOM immediately.

     PDP-104b (2026-09-06), two problems found on the LIVE theme:

     1. LOAD-TIME GUARD. The first version wrapped everything in
            var wrapper = ...; if (!wrapper || !radioFieldset) return;
        run once when this deferred file executed. On live that ran
        before <product-info> had the buy box ready, so the guard
        bailed and the change listener was NEVER attached — the
        price fell back to the theme's slow path on every product.
        Fix: no load-time DOM guard. The delegated change listener
        is attached unconditionally (it is on document and costs
        nothing until an options[...] control changes); every DOM /
        variant check happens lazily inside the handler.

     2. THE THEME SYNC-SWAPS THE PRICE NODE. Right after our
        capture-phase paint, product-info's own handler replaces
        the price node with a pending state in the SAME click, so
        a synchronous read afterwards showed the old value again.
        Fix: repaint on the next animation frame (~16ms), which
        runs after the theme's synchronous swap, plus two later
        re-asserts to cover the async section patch landing late.
     ---------------------------------------------------------- */
  var variants = null;
  var loading = false;

  function loadVariants() {
    if (variants || loading) { return; }
    loading = true;
    fetch(location.pathname + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.variants) { variants = p.variants; } loading = false; })
      .catch(function () { loading = false; /* theme's own update still works */ });
  }
  loadVariants();

  function rupees(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function selectedOptions() {
    var vals = [];
    var checked = document.querySelectorAll('.product-single__details input[type="radio"][name^="options["]:checked');
    for (var i = 0; i < checked.length; i++) { vals.push(checked[i].value); }
    var selects = document.querySelectorAll('.product-single__details select[name^="options["]');
    for (var j = 0; j < selects.length; j++) { vals.push(selects[j].value); }
    return vals;
  }

  function matchVariant() {
    if (!variants) { return null; }
    var sel = selectedOptions();
    if (!sel.length) { return null; }
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options;
      if (opts.length !== sel.length) { continue; }
      var hit = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== sel[j]) { hit = false; break; }
      }
      if (hit) { return variants[i]; }
    }
    return null;
  }

  function paint() {
    var v = matchVariant();
    if (!v) { return; }
    var price = rupees(v.price);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;

    // Main buy box price. The sticky ATC bar reuses the same
    // data attribute, so it comes along for free.
    var priceEls = document.querySelectorAll('.product-single__wrapper [data-product-price], [data-product-price][class*="sticky-atc-price"]');
    for (var i = 0; i < priceEls.length; i++) {
      if (priceEls[i].textContent.trim() !== price) { priceEls[i].textContent = price; }
    }

    var compareEls = document.querySelectorAll('.product-single__wrapper [data-compare-price]');
    for (var j = 0; j < compareEls.length; j++) {
      var want = onSale ? rupees(v.compare_at_price) : '';
      if (compareEls[j].textContent.trim() !== want) { compareEls[j].textContent = want; }
      compareEls[j].style.display = onSale ? '' : 'none';
    }
  }

  // Unconditional delegated + capture listener. paint() runs
  // immediately, again on the next frame (to beat the theme's
  // synchronous node swap), then twice more to overwrite the async
  // section patch's wrong intermediate state if it lands late.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name || t.name.indexOf('options[') !== 0) { return; }
    if (!t.closest || !t.closest('.product-single__details')) { return; }
    if (!variants) { loadVariants(); }
    paint();
    if (window.requestAnimationFrame) { requestAnimationFrame(paint); }
    setTimeout(paint, 300);
    setTimeout(paint, 800);
  }, true);
})();